import customValidator from '../utility/custom-validator'
import GetCodeSuccessDialog from '@/components/elements/dialog/GetCodeSuccessDialog'
import ErrorDialog from '@/components/elements/dialog/ErrorDialog'
import SuccessDialog from '@/components/elements/dialog/SuccessDialog'
import storage from '../utility/storage'
import FormHeader from '@/components/forms/FormHeader';
import {add, decimal, inBetween} from "../utility/number.util";
import {mapGetters} from "vuex";

export const withdrawalFormMixin = {
	components: {FormHeader, GetCodeSuccessDialog, ErrorDialog, SuccessDialog},
	props: {
		paymentOption: {
			type: String
		},
		customerPaymentOption: {
			type: Object,
		}
	},
	data() {
		return {
			member: storage.getObject('member'),
			settings: storage.getObject('settings'),
			memberEmail: storage.getObject('member').user.email,
			customerProduct: storage.getObject('products'),
			message: '',
			dialog: false,
			successDialog: false,
			errorDialog: false,
			lazy: false,
			loadingGetCode: false,
			loading: false,
			currency: 'EUR',
			valid: false,
			form: null,
		}
	},
	mounted() {
		this.form = this.isBitcoin ?
			{receive_address: '', btcAmount: '0.00', eurAmount: '0.00', verification_code: ''} :
			{email: '', amount: '', verification_code: ''}

		if (this.isBitcoin) {
			this.form.receive_address = this.customerPaymentOption.fields[0].account_id.value
		} else {
			this.form.email = this.customerPaymentOption.fields[0].email.value
		}
	},

	computed: {
		total() {
			return this.form.amount
		},
		totalAmountToBeWithdrawn () {
			return add(this.form.amount, this.customerFee)
		},
		customerFee () {
			return this.computeFee('member')
		},
		companyFee () {
			return this.computeFee('company')
		},
		hasPaymentOptionEmailRegistered () {
			return this.customerPaymentOption.fields[0].email.value !== ''
		},
		ui () {
			let meta = { }
			switch (this.customerPaymentOption.code) {
				case 'BITCOIN':
					meta.logo = require('@/assets/gateway-bitcoin-logo.svg')
					meta.classes = { 'gradient-bitcoin': true }
					break
				case 'SKRILL':
					meta.logo = require('@/assets/gateway-skrill-logo.svg')
					meta.classes = { 'gradient-skrill': true }
					break
				case 'NETELLER':
					meta.logo =  require('@/assets/gateway-neteller-logo.svg')
					meta.classes = { 'gradient-neteller': true }
					break
			}

			return meta
		},
		formRules () {
			return {
				email: [
					value => !!value || 'Email is required',
					value => /.+@.+\..+/.test(value) || 'E-mail must be valid',
				],
				receive_address: [
					value => !!value || 'Receive Address is required',
				],
				amount: [
					value => !!value || 'Amount is required',
					value => decimal(value).greaterThanOrEqualTo(this.bundleFieldValue('min_withdrawal')) || `Amount should be greater than ${this.bundleFieldValue('min_withdrawal')} but less than ${this.bundleFieldValue('max_withdrawal')}`,
					value => decimal(value).lessThanOrEqualTo(this.bundleFieldValue('max_withdrawal')) || `Amount should be greater than ${this.bundleFieldValue('min_withdrawal')} but less than ${this.bundleFieldValue('max_withdrawal')}`,
				],
				btcAmount: [
					value => !!value || 'Amount is required',
					value => !decimal(value).greaterThan(this.maximumAmountWithdrawal) || 'Above maximum amount',
					value => !decimal(value).lessThan(this.minimumAmountWithdrawal) || 'Below minimum amount'
				],
				verification_code: [
					value => !!value || 'Verification is required',
					() => {
						let verificationError = null
						if (this.apiErrors[this.customerPaymentOption.code]) {
							verificationError = this.apiErrors[this.customerPaymentOption.code].filter((error) => {
								return error.field = 'verification_code'
							})
						}
						if (verificationError !== null) {
							return verificationError[0].message
						}

						return true
					}
				]
			}
		},
		isBitcoin () {
			return this.customerPaymentOption.code === 'BITCOIN'
		},
		...mapGetters('withdrawal', [
			'apiErrors'
		])
	},
	methods: {
		requestCode() {
			let isValid = false
			let ref = null
			if (this.customerPaymentOption.code === 'BITCOIN') {
				isValid = !customValidator.empty(this.form.receiveAddress)
				ref = this.$refs.receiveAddress
			} else {
				isValid = !customValidator.empty(this.form.email) && customValidator.email(this.form.email)
				ref = this.$refs.email
			}

			if (isValid) {
				this.loadingGetCode = true
				this.$store.dispatch('account/getCode', {'email': this.memberEmail, 'purpose': 'transaction'}).then(() => {
					this.dialog = true
					this.$refs.childGetCodeSuccess.setOpen(true)
					this.loadingGetCode = false
				}).catch((err) => {
					this.$ref.form.validate()
					this.message = err.response.data.errors[0].message
					this.errorDialog = true
					this.$refs.childError.setOpen(true)
					this.loadingGetCode = false
				})
			} else {
				ref.focus()
				this.loadingGetCode = false
			}
		},
		submit() {
			if (customValidator.zero(this.member.available_balance)) {
				this.message = 'Unable to withdraw with 0.00 Balance.'
				this.errorDialog = true
				this.$refs.childError.setOpen(true)
			} else {
				this.$validator.validateAll().then((result) => {
					if (result) {
						this.loading = true

						this.$store.dispatch('withdrawal/withdraw', this.getPayload()).then((response) => {
							this.message = response.message
							this.successDialog = true
							this.$refs.childSuccess.setOpen(true)
							this.loading = false
						}).catch(() => {
							this.$refs.form.validate()
							this.loading = false
						})
					}
				})
			}
		},
		getPayload() {
			return {
				verification_code: this.form.verification_code,
				payment_option_type: this.paymentOption,
				customer_fee: this.customerFee,
				company_fee: this.companyFee,
				products: [{
					username: this.customerProduct.username,
					product_code: this.customerProduct.product.code,
					amount: this.form.amount,
				}],
				meta: {
					field: {
						email: this.form.email
					}
				}
			}
		},
		getFeeSetting(type) {
			const feeSettings = this.customerPaymentOption.fees.withdrawal[type]
			if (!this.customerPaymentOption.fees.enabled) return null
			if (this.customerPaymentOption.fees.withdrawal[type].length !== 0) return null

			return feeSettings.filter((setting) => {
				if (setting.from !== null) {
					return inBetween(this.form.amount, setting.from, setting.to)
				}
			});
		},
		computeFee(type) {
			let actualFee = '0.00'
			let feeSetting = this.getFeeSetting(type)

			if (feeSetting) {
				const customFee = this.form.amount * ((feeSetting[0].percentage).valueOf() / 100);
				actualFee = customFee.toString();
			} else {
				actualFee = this.bundleFieldValue(`withdrawal_fee`).toLowerCase() === 'free' ? '0.00' : this.bundleFieldValue(`withdrawal_fee`);
				if (actualFee.includes('%')) {
					const percentage = parseFloat(actualFee.slice(0, -1));
					const bundleFee = decimal(this.form.amount)
						.mul(decimal(percentage.valueOf())
						.div(decimal(100)))

					actualFee = bundleFee.toString()
				}
			}
			return actualFee
		},
		bundleFieldValue(fieldName) {
			const field = this.customerPaymentOption.bundle.data.filter(f => f.name === fieldName).pop();
			return field ? field.value : '';
		}
	},
}